import styled, { css } from '@app/styled';
import { color, modifier, radius, spacing, typography, variants } from '@app/theme';

export const Container = styled.div<{ $noBorder: boolean }>`
    display: block;
    width: 100%;
    background-color: ${color('background.surface.middle')};
    border-radius: ${radius('m')};
    border: 1px solid ${color('border.default')};
    ${typography('custom.description')}

    ${modifier(
        '$noBorder',
        css`
            border: none;
        `,
    )}
`;

export const Header = styled.button<{ $iconPosition: 'left' | 'right' }>`
    width: 100%;
    display: flex;
    border: none;
    background-color: transparent;
    padding: ${spacing(2)};

    ${variants(
        '$iconPosition',
        {
            left: css`
                align-items: center;
                justify-content: start;
                gap: ${spacing(3)};
            `,
            right: css`
                align-items: center;
                justify-content: space-between;
            `,
        },
        'right',
    )}
`;

export const Title = styled.h5``;

export const Content = styled.div<{ $expanded: boolean }>`
    height: 0;
    visibility: collapse;
    padding: 0;
    ${modifier(
        '$expanded',
        css`
            height: auto;
            visibility: visible;
            padding: ${spacing(0, 2, 2)};
        `,
    )};
`;

export const IconWrapper = styled.div<{ $expanded: boolean }>`
    display: flex;
    align-items: center;
    transform: rotate(0deg);
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    ${modifier(
        '$expanded',
        css`
            transform: rotate(180deg);
        `,
    )};
`;
